import { render, staticRenderFns } from "./addPatientStories.vue?vue&type=template&id=8977c2b6"
import script from "./addPatientStories.vue?vue&type=script&lang=js"
export * from "./addPatientStories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports